
module.exports = {
  // TODO: change your profile information here
  name: "Divya jain",
  greeting: "Hey 👋",
  greetingDescription: "I'm Divya jain and I'm a Software Engineer!",
  githubUrl: "https://github.com/div53",
  linkedinUrl: "https://www.linkedin.com/in/divy-jain-605110168/",
  cvLink: "",
};
